import styled from "styled-components";

export const AssetWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

export const AssetSelector = styled.div`
  position: relative;
  display: flex;
  flex-basis: calc(50% - 5px);
  min-height: 100px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #abb4f4;
  background: #dce0fc;
  cursor: pointer;
`;

export const AssetContainer = styled.img`
  width: 100%;
  height: 100%;
  object-fit: ${({ isLogo }) => (isLogo ? "contain" : "cover")};
  border-radius: 8px;
`;

export const ImageSelectionWrapper = styled.div`
  position: absolute;
  top: 5%;
  right: 5%;
`;
